/**
 * External dependencies
 */
import { css } from '@emotion/core';

export default css;
